module.exports = __webpack_public_path__ + "img/expovina-primavera_05(1).41bef5fb.jpg";